import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

type BreadcrumbPathStyleProps = {
  isInteractive: boolean;
};

const breadcrumbPathStyle = ({ isInteractive }: BreadcrumbPathStyleProps) =>
  css`
    &:not(:last-of-type) {
      color: ${isInteractive ? theme.font.colors.primary : theme.font.colors.default};
    }

    &:last-of-type {
      color: ${theme.font.colors.default};
    }
  `;

export const BreadcrumbPathStyles = {
  breadcrumbPathStyle: (props: BreadcrumbPathStyleProps) => breadcrumbPathStyle(props),
};
